import React from "react";
import { useTour } from "../contexts/TourContext"; // Importamos el hook del tour

function Footer() {
  const { startTour } = useTour(); // Obtenemos la función para iniciar el tour desde el contexto
  const handleHowItWorksClick = (e) => {
    e.preventDefault(); // Prevenimos el comportamiento por defecto del enlace
    startTour(); // Llamamos a la función global para iniciar el tour
  };

  return (
    <footer className="bg-[#F5F7FA] mt-16 pt-12 pb-6 border-t border-gray-200">
      <div className="max-w-7xl w-full mx-auto px-8 flex flex-col md:flex-row justify-between gap-12">
        <div>
          <div className="flex items-center gap-2 mb-2">
            <img
              src="/images/LogoAlquilalo-360x90-VerdeOscuro.png"
              alt="Alquilalo"
              className="h-12 w-auto"
            />
          </div>
          <p className="text-gray-600 text-sm max-w-xs">
            Alquila lo que necesitas, cuando lo necesitas. Ahorra dinero, reduce
            el impacto ambiental y únete a la comunidad de consumo colaborativo.
          </p>
        </div>
        <div className="flex flex-col gap-2">
          <span className="font-semibold text-gray-700 mb-1">
            Enlaces Rápidos
          </span>
          <button
            onClick={handleHowItWorksClick}
            className="text-gray-700 hover:text-[#009688] text-sm text-left"
          >
            Cómo Funciona
          </button>
          <a
            href="/publicar"
            className="text-gray-700 hover:text-[#009688] text-sm"
          >
            Publicar un Artículo
          </a>
          <a
            href="/ayuda"
            className="text-gray-600 hover:text-[#00695C] text-sm"
          >
            Centro de Ayuda
          </a>

          {/*<a
            href="/blog"
            className="text-gray-500 hover:text-[#009688] text-sm"
          >
            Blog
          </a>*/}
        </div>
        <div className="flex flex-col gap-2">
          <span className="font-semibold text-gray-700 mb-1">Legal</span>
          <a
            href="/terminos-y-condiciones"
            className="text-gray-600 hover:text-[#00695C] text-sm"
          >
            Términos de Servicio
          </a>
          <a
            href="/politica-de-privacidad"
            className="text-gray-600 hover:text-[#00695C] text-sm"
          >
            Política de Privacidad
          </a>
          <a
            href="/politica-de-cookies"
            className="text-gray-600 hover:text-[#00695C] text-sm"
          >
            Política de Cookies
          </a>
        </div>
        <div>
          <span className="font-semibold text-gray-700 mb-1">Síguenos</span>
          <div className="flex gap-3 mt-2">
            <a
              href="https://www.facebook.com/AlquilaloArgentina"
              aria-label="Facebook"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg
                className="h-5 w-5 text-[#009688]"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M22 12c0-5.522-4.478-10-10-10S2 6.478 2 12c0 4.991 3.657 9.128 8.438 9.877v-6.987h-2.54v-2.89h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.242 0-1.632.771-1.632 1.562v1.875h2.773l-.443 2.89h-2.33v6.987C18.343 21.128 22 16.991 22 12" />
              </svg>
            </a>
            <a
              href="https://www.instagram.com/alquilalo_argentina"
              aria-label="Instagram"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg
                className="h-5 w-5 text-[#009688]"
                fill="currentColor"
                viewBox="0 0 50 50"
              >
                <path d="M15 8h20c3.9 0 7 3.1 7 7v20c0 3.9-3.1 7-7 7H15c-3.9 0-7-3.1-7-7V15c0-3.9 3.1-7 7-7zm0 4c-1.7 0-3 1.3-3 3v20c0 1.7 1.3 3 3 3h20c1.7 0 3-1.3 3-3V15c0-1.7-1.3-3-3-3H15z" />
                <circle
                  cx="25"
                  cy="25"
                  r="7"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="3"
                />
                <circle cx="35" cy="15" r="2" />
              </svg>
            </a>

            <a
              href="https://x.com/AlquilaloArg"
              aria-label="Twitter"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg
                className="h-5 w-5 text-[#009688]"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M24 4.557a9.93 9.93 0 0 1-2.828.775 4.932 4.932 0 0 0 2.165-2.724c-.951.564-2.005.974-3.127 1.195a4.92 4.92 0 0 0-8.384 4.482C7.691 8.095 4.066 6.13 1.64 3.161c-.542.929-.856 2.01-.857 3.17 0 2.188 1.115 4.116 2.823 5.247a4.904 4.904 0 0 1-2.229-.616c-.054 2.281 1.581 4.415 3.949 4.89a4.936 4.936 0 0 1-2.224.084c.627 1.956 2.444 3.377 4.6 3.417A9.867 9.867 0 0 1 0 21.543a13.94 13.94 0 0 0 7.548 2.212c9.058 0 14.009-7.513 14.009-14.009 0-.213-.005-.425-.014-.636A10.025 10.025 0 0 0 24 4.557z" />
              </svg>
            </a>

            <a
              href="https://tiktok.com/@alquilaloargentina"
              aria-label="TikTok"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg
                className="h-5 w-5 text-[#009688]"
                fill="currentColor"
                viewBox="0 0 50 50"
              >
                <path d="M34.5 12.5c-2.5-1.8-4-4.5-4-7.5h-5v28c0 4.4-3.6 8-8 8s-8-3.6-8-8 3.6-8 8-8c0.8 0 1.6 0.1 2.3 0.4v-5.2c-0.7-0.1-1.5-0.2-2.3-0.2-6.6 0-12 5.4-12 12s5.4 12 12 12 12-5.4 12-12V18c2.6 1.9 5.8 3 9.2 3v-5c-1.5 0-2.9-0.4-4.2-1.5z" />
                <circle
                  cx="25"
                  cy="25"
                  r="7"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="3"
                />
                <circle cx="35" cy="15" r="2" />
              </svg>
            </a>

            <a
              href="https://youtube.com/@AlquilaloArgentina"
              aria-label="YouTube"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg
                className="h-5 w-5 text-[#009688]"
                fill="currentColor"
                viewBox="0 0 50 50"
              >
                <path d="M43.2 16.3c-0.5-1.8-1.9-3.2-3.7-3.7C36.4 12 25 12 25 12s-11.4 0-14.5 0.6c-1.8 0.5-3.2 1.9-3.7 3.7C6.2 19.4 6.2 25.5 6.2 25.5s0 6.1 0.6 9.2c0.5 1.8 1.9 3.2 3.7 3.7C13.6 39 25 39 25 39s11.4 0 14.5-0.6c1.8-0.5 3.2-1.9 3.7-3.7 0.6-3.1 0.6-9.2 0.6-9.2s0-6.1-0.6-9.2zM21 31V20l9.5 5.5L21 31z" />
                <circle
                  cx="25"
                  cy="25"
                  r="7"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="3"
                />
                <circle cx="35" cy="15" r="2" />
              </svg>
            </a>
          </div>
        </div>
      </div>
      <div className="max-w-7xl w-full mx-auto px-8 mt-8 flex flex-col md:flex-row justify-between items-center text-xs text-gray-400">
        <span>
          {" "}
          2025 Alquilalo. Todos los derechos reservados. Plataforma de alquiler
          en Argentina.
        </span>

        {/*<div className="flex gap-4 mt-2 md:mt-0">
          <a href="/mapa-del-sitio" className="hover:text-[#009688]">
            Mapa del Sitio
          </a>
          <a href="/accesibilidad" className="hover:text-[#009688]">
            Accesibilidad
          </a>
        </div>*/}
      </div>
    </footer>
  );
}

export default Footer;
